import { format } from "date-fns";
const COLUMNS = [
  {
    Header: "Sr. No.",
    accessor: "rowIndex",
    Cell: (row) => {
      return <span>{row.cell?.row.index + 1}</span>; // Adding 1 to make it 1-based;
    },
  },
  {
    Header: "",
    accessor: "eventMedia",
    Cell: (row) => {
      return (
        <span className="flex items-center h-16  max-w-22 min-w-18 mr-8">
          <img
            src={"https://via.placeholder.com/150"} // Assuming the first image in the array
            alt="Event"
            className="w-full h-full rounded-md"
          />
        </span>
      );
    },
  },
  {
    Header: "Event Name",
    accessor: "eventName",
    Cell: (row) => {
      return <span>{row?.cell?.value || "Event Name"}</span>;
    },
  },
  {
    Header: "Event Date",
    accessor: "eventDate",
    Cell: (row) => {
      return <span>{format(row?.cell?.value, "dd/MM/yyyy")}</span>;
    },
  },
  {
    Header: "Revenue",
    accessor: "totalRevenue",
    Cell: (row) => {
      return <span>{row?.cell?.value || "0.00"}</span>; // Format date
    },
  },
  {
    Header: "Tickets Sold",
    accessor: "totalTicketsSold",
    Cell: (row) => {
      return <span>{row?.cell?.value || "0"}</span>;
    },
  },

  {
    Header: "Customers",
    accessor: "eventVenueDetails.noOfPeoples",
    Cell: (row) => {
      return <span>{row?.cell?.value | 0}</span>;
    },
  },
];

export default COLUMNS;
